export default "__VITE_ASSET__DHN9_Dx2__"